import createIcon from '../../createIcon';

/**
 * @component @name AssistantPhoto
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuOSA1LjVMMTMuNSAzLjVINC41VjIwLjVINi41VjEzLjVIMTIuMUwxMi41IDE1LjVIMTkuNVY1LjVIMTMuOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AssistantPhoto = createIcon('AssistantPhoto', [
  [
    'path',
    { d: 'M13.9 5.5L13.5 3.5H4.5V20.5H6.5V13.5H12.1L12.5 15.5H19.5V5.5H13.9Z', key: '142m3e' },
  ],
]);

export default AssistantPhoto;
